"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerServiceButtonValues = void 0;
const CustomerServiceButtonValues = exports.CustomerServiceButtonValues = {
  POSITIVE_FEEDBACK: 'positive-feedback',
  NEGATIVE_FEEDBACK: 'negative-feedback',
  EXIT_BOT: 'exit'
};

// TODO; Thiago; 31.01.2024; Remove `exitButtonText`, `positiveFeedbackText` and `negativeFeedbackText`
// after migrating these values to the `buttons`.